import { render } from "./OrderItemsTable.html?vue&type=template&id=b2cb8fc4&scoped=true"
import script from "./OrderItemsTable.js?vue&type=script&lang=js"
export * from "./OrderItemsTable.js?vue&type=script&lang=js"

import "./OrderItemsTable.css?vue&type=style&index=0&id=b2cb8fc4&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2cb8fc4"]])

export default __exports__